export function shouldUseSentry() {
    return ENV?.isProduction && !window.disableSentry
}
